import PurchaseHistoryOrderItem from "@/pages/Home/PurchaseHistory/OrderItem";
import { useAppTranslation } from "@/utils";
import { bnplConsumerApis } from "@payping/api";
import { Alert, Divider, Flex, useMessagedAsync } from "@payping/web-components";
import Loading from "@/pages/loading";
import { OrderStatusRequest } from "@payping/api/app/api/bnplConsumerTypes";
import { PPFullColorLogoFa } from "@/core/utils";

interface PlanProps {
  errorMessages: { code: string; message: string }[];
}

const ActiveInstallmentLimit = ({ errorMessages }: PlanProps) => {
  const { t } = useAppTranslation();
  const merchantId = Number(
    errorMessages.find((a) => a.code === "payping.order_same_merchant_limit_merchantid")?.message ?? "0",
  );

  const listState = useMessagedAsync(
    async () => {
      const res = await bnplConsumerApis.dashboardOrderList(
        undefined,
        undefined,
        OrderStatusRequest.NotPaidOff,
        merchantId,
        1000,
        1,
      );

      return res;
    },
    [merchantId],
    {
      success: false,
      error: true,
    },
  );

  if (listState.loading) {
    return <Loading />;
  }

  return (
    <Flex className="tw:h-full" vertical>
      <Flex className="tw:w-full tw:p-5!" align="center">
        <img src={PPFullColorLogoFa} width={60} height={24} />
      </Flex>
      <Divider className="tw:m-0!" />
      <Flex vertical className="tw:h-full tw:w-full tw:p-3!">
        <Flex className="tw:mt-1! tw:w-full tw:p-1!" gap="middle" vertical>
          <Alert
            title={null}
            description={
              <Flex vertical gap={"small"}>
                <span>{t("pay.activeInstallmentLimitTitle")}</span>
                <span>{t("pay.activeinstallmentLimitContent")}</span>
              </Flex>
            }
            type="warning"
            showIcon
          />
        </Flex>
        <Flex className="tw:mt-2! tw:w-full tw:p-1!" gap="middle" vertical>
          {listState.value?.orders.map((item) => (
            <PurchaseHistoryOrderItem key={item.trackingCode} data={item} />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ActiveInstallmentLimit;
